<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <img src="../assets/logo.svg" class="login-logo" alt="Logo" />
        <h2 class="login-title">SmartAI 管理平台</h2>
      </div>

      <!-- 表单切换tabs -->
      <div class="form-tabs">
        <div class="tab-item" :class="{ 'active': activeTab === 'login' }" @click="activeTab = 'login'">
          登录
        </div>
        <div class="tab-item" :class="{ 'active': activeTab === 'register' }" @click="activeTab = 'register'">
          注册
        </div>
      </div>

      <!-- 登录表单 -->
      <div class="login-form" v-show="activeTab === 'login'">
        <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
          <el-form-item prop="phone">
            <el-input v-model="loginForm.phone" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号码">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" placeholder="请输入密码" show-password>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="loginForm.remember">记住我</el-checkbox>
            <span class="forgot-password">忘记密码?</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="submit-button" @click="handleLogin">登录</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 注册表单 -->
      <div class="register-form" v-show="activeTab === 'register'">
        <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
          <el-form-item prop="phone">
            <el-input v-model="registerForm.phone" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号码">
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="registerForm.password" prefix-icon="el-icon-lock" placeholder="请输入密码" show-password>
            </el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input v-model="registerForm.confirmPassword" prefix-icon="el-icon-lock" placeholder="请确认密码"
              show-password>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="submit-button" @click="handleRegister">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    // 确认密码的验证规则
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    return {
      activeTab: 'login',
      loginForm: {
        phone: '',
        password: '',
        remember: false
      },
      registerForm: {
        phone: '',
        password: '',
        confirmPassword: ''
      },
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ]
      },
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // 验证默认账号密码
          if (this.loginForm.phone === '13927459644' && this.loginForm.password === '123admin3935') {
            // 登录成功，存储登录状态
            localStorage.setItem('isLoggedIn', 'true');
            localStorage.setItem('userName', 'uLike');

            // 跳转到模板中心
            this.$router.push('/template');

            this.$message.success('登录成功');
          } else {
            this.$message.error('手机号码或密码错误');
          }
        } else {
          return false;
        }
      });
    },
    handleRegister () {
      this.$refs.registerForm.validate(valid => {
        this.$message.success('暂不对外开放注册功能');
        // if (valid) {
        //   // 这里只是模拟注册成功，实际应该连接后端API
        //   this.$message.success('注册成功，请使用新账号登录');
        //   this.activeTab = 'login';
        //   this.loginForm.phone = this.registerForm.phone;
        //   this.loginForm.password = '';
        // } else {
        //   return false;
        // }
      });
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f2f5;
  background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.login-box {
  width: 400px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 40px;
}

.login-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.login-logo {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
}

.login-title {
  font-size: 24px;
  color: #303133;
  margin: 0;
}

.form-tabs {
  display: flex;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 25px;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.tab-item.active {
  color: #409EFF;
  font-weight: 500;
}

.tab-item.active:after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  height: 2px;
  background-color: #409EFF;
}

.tab-item:hover {
  color: #409EFF;
}

.forgot-password {
  float: right;
  color: #409EFF;
  cursor: pointer;
}

.submit-button {
  width: 100%;
  margin-top: 10px;
}
</style>